import React from "react";
import { GoalToggleButton } from "./goal-toggle-button";

interface FilterTileProps {
    icon: (className: string) => React.ReactNode;
    label: string;
    hint: string | null;
    count: number;
    countSuffix: React.ReactNode;
    meter: React.ReactNode;
    footer: React.ReactNode;
    selected: boolean;
    onToggle: () => void;
}

export const FilterTile: React.FC<FilterTileProps> = props => (
    <GoalToggleButton
        selected={props.selected}
        onToggle={props.onToggle}
        className="min-w-0 rounded-lg px-3 py-2.5">
        <div className="flex items-center gap-1.5" title={props.hint ?? undefined}>
            {props.icon("h-4 w-4 flex-shrink-0 text-gray-500")}
            <span className="truncate text-xs font-semibold text-zinc-800">
                {props.label}
            </span>
        </div>
        <div className="mt-1.5 flex items-baseline gap-1">
            <span className="text-xl font-bold leading-none tabular-nums text-zinc-950">
                {props.count}
            </span>
            {props.countSuffix}
        </div>
        {props.meter ? <div className="mt-2">{props.meter}</div> : null}
        <div className="mt-1.5 text-[11px] text-gray-500">{props.footer}</div>
    </GoalToggleButton>
);
